module.exports = __webpack_public_path__ + "img/xiaodiaoya.96720398.png";